<template>
  <div class="contact-form-area pb-100">
    <div class="container">
      <div class="row">
        <div class="col-lg-6">
          <div class="contact-form-map">
            <iframe
              style="
                width: 100%;
                height: 378px;
                border-radius: 10px;
                display: block;
              "
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3155.7252813160476!2d-122.40609221071485!3d37.726125742770115!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808f7f1df686746d%3A0x8e6f9273562379e3!2s1485%20Bayshore%20Blvd%20%23154%2C%20San%20Francisco%2C%20CA%2094124%2C%20USA!5e0!3m2!1sen!2sbd!4v1707982401773!5m2!1sen!2sbd"
            ></iframe>
          </div>
        </div>

        <div class="col-lg-6">
          <div class="contact-form-content">
            <span class="top-title">أرسل لنا رسالة</span>
            <h2>سنتواصل معك في أقرب وقت</h2>
            <p>
              نحن هنا لخدمتكم! إذا كان لديك أي استفسار، ملاحظة، أو تعليق حول خدماتنا، لا تتردد في التواصل معنا عبر النموذج أدناه.
            </p>
          </div>

          <div class="contact-form">
            <form>
              <div class="row">
                <div class="col-lg-6">
                  <div class="form-floating mb-4">
                    <input
                      type="text"
                      class="form-control"
                      id="floatingInput1"
                      placeholder="الاسم"
                    />
                    <label for="floatingInput1">الاسم</label>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="form-floating mb-4">
                    <input
                      type="email"
                      class="form-control"
                      id="floatingInput2"
                      placeholder="البريد الإلكتروني"
                    />
                    <label for="floatingInput2">البريد الإلكتروني</label>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="form-floating mb-4">
                    <input
                      type="text"
                      class="form-control"
                      id="floatingInput3"
                      placeholder="رقم الهاتف"
                    />
                    <label for="floatingInput3">رقم الهاتف</label>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="form-floating mb-4">
                    <input
                      type="text"
                      class="form-control"
                      id="floatingInput4"
                      placeholder="نوع الاشتراك"
                    />
                    <label for="floatingInput4">نوع الاشتراك</label>
                  </div>
                </div>
                <div class="col-lg-12">
                  <div class="form-floating mb-4">
                    <textarea
                      class="form-control"
                      id="floatingInput5"
                      placeholder="اكتب رسالتك هنا"
                      cols="30"
                      rows="5"
                    ></textarea>
                    <label for="floatingInput5">اكتب رسالتك هنا</label>
                  </div>
                </div>
                <div class="col-lg-12">
                  <div class="form-check mb-4">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="flexCheckDefault"
                    />
                    <label class="form-check-label" for="flexCheckDefault">
                      الموافقة على سياسة الخصوصية وشروط الاستخدام.
                    </label>
                  </div>
                </div>
                <div class="col-lg-12">
                  <button type="submit" class="btn">
                    <span class="border-style">إرسال الرسالة الآن</span>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "ContactForm",
});
</script>